<template>
  <div class="topbar-root">
    <img class="icon" src="../assets/logo-small.png" alt />
    <div class="title">Regents HR Portal</div>
    <div>
      <i
        class="far fa-question-circle question-mark"
        @click="question.isShowing = true"
      ></i>
    </div>
    <Modal
      :isShowing.sync="question.isShowing"
      :title="'Help'"
      :size="'width:60vw;height:150px;'"
    >
      <div>
        For any help or query, please contact HR in person or via email:
        hrd@regentsschoolbali.com
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../digilib_web/vue/modal';

export default {
  mounted() {},
  data() {
    return {
      question: { isShowing: false }
    };
  },
  components: {
    Modal
  }
};
</script>

<style scoped>
.topbar-root {
  border-bottom: 1px solid rgba(45, 130, 255, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.title {
  color: rgba(86, 145, 176, 1);
  font-size: 20px;
  text-transform: uppercase;
}
.icon {
  width: 40px;
  height: 48px;
}
.question-mark {
  font-size: 36px;
  cursor: pointer;
}
@media screen and (max-width: 1024px) {
  .title {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .topbar-root {
    display: none;
  }
}
</style>
